import './App.css';
import VerifyMember from './VerifyMember';
import Home from './Home/index';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HospitalValidation from './HospitalValidation/HospitalValidation';
import ProtectedRoute from './ProtectedRoute/ProtectedRoute';
import Customers from './Customers/Customers';
import ConfirmBooking from './ConfirmBooking/ConfirmBooking';
import HospitalRoute from './HospitalRoute/HospitalRoute';
import HospitalDashboard from './HospitalDashboard/HospitalDashboard';
import MobileFooter from './MobileFooter/MobileFooter';

function App() {
    return (
        <Router>
            <div className="mobile-shell">
                <div className="mobile-shell__content">
                    <Routes>
                        <Route path="/" element={<HospitalValidation />} />

                        <Route element={<HospitalRoute />}>
                            <Route path="/verify" element={<VerifyMember />} />
                            <Route path="/customerslist" element={<Customers />} />
                            <Route path="/dashboard" element={<HospitalDashboard />} />
                        </Route>

                        <Route element={<ProtectedRoute />}>
                            <Route path="/bookconsultation" element={<Home />} />
                        </Route>

                        <Route path="/confirmBooking/:Id" element={<ConfirmBooking />} />
                    </Routes>
                </div>
                <MobileFooter />
            </div>
        </Router>
    );
}

export default App;
